<hr />
<div>
  <p class="mb-1">Contexto</p>
  <p class="context">
    {{ log.context }}
  </p>
  <p class="event-date">
    <span>Fecha: {{ log.date | date : "medium" }}</span>
  </p>
  <hr />
  <p class="mb-1">Valores Viejos</p>
  <div class="row context">
    <div class="col-6">Estatus</div>
    <div class="col-6">Monto</div>
  </div>
  <div class="row table-body">
    <div class="col-6">{{ log.oldStatus }}</div>
    <div class="col-6">{{ log.oldFinalAmount | customCurrency }}</div>
  </div>
  <hr />
  <p class="mb-1">Valores Nuevos</p>
  <div class="row context">
    <div class="col-6">Estatus</div>
    <div class="col-6">Monto</div>
  </div>
  <div class="row table-body">
    <div class="col-6">{{ log.newStatus }}</div>
    <div class="col-6">{{ log.newFinalAmount | customCurrency }}</div>
  </div>
</div>
